import type { List } from '@gonfalon/immutable-shim/immutableShim';
import type { ImmutableServerError } from '@gonfalon/legacy-http-client/httpUtils';
import http, { jsonToImmutable, jsonToImmutableError } from '@gonfalon/legacy-http-client/httpUtils';
import type { ImmutableMap } from '@gonfalon/legacy-immutable/immutableUtils';
import qs from 'qs';

import type { TagKind } from '#components/tagFilter/types';

type TagsData = ImmutableMap<{ items: List<string> }>;

export function fetchTags(
  pre: string | null,
  kind?: TagKind,
  archived?: boolean,
): Promise<List<string> | ImmutableServerError> {
  const limit = 50;
  const url = `/api/v2/tags?${qs.stringify(
    { pre, kind, archived, limit },
    {
      skipNulls: true,
    },
  )}`;
  return http
    .get(url) // used on different pages so using a resource is tricky
    .then(jsonToImmutable)
    .then((data: TagsData) => data.get('items'))
    .catch(jsonToImmutableError);
}
